import { NLP_STAGE } from 'actions/searchNLP';

/**
 * Whether closing the SciSearch AI modal with X should keep the typed query for the next open.
 *
 * The query is kept while it is still unsearched: stage one with non-empty text. It does not
 * matter whether an error box or the org "not relevant" banner is showing, since both disappear
 * on reopen or on the first edit while the text is still worth keeping. Stage two means the query
 * has produced filters, so closing there clears it as before.
 *
 * @param {{ stage: string, query?: string }} modalState
 * @returns {boolean}
 */
export const keepQueryOnClose = ({ stage, query }) =>
  stage === NLP_STAGE.INPUT && Boolean(query && query.trim());
